var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F09700",
  d: "M11.968 16.087a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M11.468 8.587a.5.5 0 1 1 1 0v5a.5.5 0 1 1-1 0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F09700",
  fillRule: "evenodd",
  d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m.837-15.63a1 1 0 0 0-1.674 0l-5.989 9.17a1 1 0 0 0 .838 1.547h11.976a1 1 0 0 0 .838-1.546z",
  clipRule: "evenodd"
})));
export default SvgWarning;